module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--full-height"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "grid grid--auth"
  }, [_c('div', {
    staticClass: "grid__item grid__item--4 hide-below-medium"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--2 posr"
  }, [_c('h1', {
    staticClass: "h1 group__title mw600 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "p group__desc mb2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm._v(" "), (_vm.step === "password") ? _c('span', [(_vm.step === "password") ? _c('button', {
    staticClass: "link auth__reset c-accent ",
    on: {
      "click": _vm.onRetry
    }
  }, [_vm._v("\n            Retry Verification\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.step === "email") ? _c('ui-auth', {
    key: "reset",
    attrs: {
      "id": "reset",
      "success": _vm.onEmailSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === "otp") ? [_c('p', {
    staticClass: "medium"
  }, [_c('button', {
    staticClass: "link auth__reset",
    on: {
      "click": _vm.resendVerification
    }
  }, [_vm._v("\n              " + _vm._s(_vm.resendValidationLoading ? "Sending email…" : "Resend email") + "\n            ")])]), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "id": "verify",
      "success": _vm.onOtpSuccess,
      "fail": _vm.onOtpFail
    }
  })] : _vm._e(), _vm._v(" "), (_vm.step === "password") ? _c('ui-auth', {
    key: "resetPassword",
    attrs: {
      "id": "resetPassword",
      "success": _vm.onPasswordSetSuccess,
      "fail": _vm.onPasswordSetFail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === "password") ? _c('p', {
    staticClass: "mt2 small"
  }, [_vm._v("\n          If your email hasn't arrived, please check your spam folder or try\n          again.\n          "), _c('button', {
    staticClass: "link auth__reset",
    on: {
      "click": _vm.onRetry
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resendValidationLoading ? "Sending email…" : "Resend email") + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.resendErrorMessage), function(msg, index) {
    return _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.resendErrorMessage),
        expression: "resendErrorMessage"
      }],
      key: index,
      staticClass: "c-error mt"
    }, [_vm._v("\n          " + _vm._s(msg.message) + "\n        ")])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b39b44a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Reset.vue
// module id = 487
// module chunks = 0